function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useCallback, useRef } from 'react';
import './HelpModal.css';
import ButtonLabel from '../../Buttons/ButtonLabel/ButtonLabel';
import H from '../../H/H';
import I18n, { isI18nObject } from '../../I18n/I18n/I18n';
import IconButton from '../../Buttons/IconButton/IconButton';
import Modal from '../../Modal/Modal/Modal';
import ModalBody from '../../Modal/ModalBody/ModalBody';
import ModalHeader from '../../Modal/ModalHeader/ModalHeader';
import QuestionMark from '../../Icons/QuestionMark/QuestionMark';
import ThemeContext from '../../ThemeContext/ThemeContext';
import { focusInViewportCenter } from '../ValidationForm/validationFormUtils';
export default function HelpModal(_ref) {
  var label = _ref.label,
    _ref$escape = _ref.escape,
    escape = _ref$escape === void 0 ? true : _ref$escape,
    i18n = _ref.i18n,
    title = _ref.title;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showHelp = _useState2[0],
    setHelp = _useState2[1];
  var showModal = useCallback(function () {
    return setHelp(true);
  }, []);
  var buttonRef = useRef();
  var closeModal = useCallback(function () {
    setHelp(false);
    if (buttonRef && buttonRef.current) {
      focusInViewportCenter(buttonRef.current);
    }
  }, [buttonRef]);
  return /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: 'dm'
  }, /*#__PURE__*/React.createElement(IconButton, {
    onClick: showModal,
    ref: buttonRef,
    className: "_dm-button--help auto-help-modal"
  }, label && /*#__PURE__*/React.createElement(ButtonLabel, {
    i18n: label,
    hideLabel: true
  }), /*#__PURE__*/React.createElement(QuestionMark, {
    width: 12,
    height: 12,
    className: "_dm-icon--help-input"
  })), /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: "ripple"
  }, /*#__PURE__*/React.createElement(Modal, {
    modifier: "help",
    titleText: title,
    mounted: showHelp,
    onExit: closeModal,
    maxWidth: '34rem'
  }, title && /*#__PURE__*/React.createElement(ModalHeader, null, /*#__PURE__*/React.createElement(H, {
    className: "_dm-modal__title"
  }, /*#__PURE__*/React.createElement(I18n, {
    i18n: title
  }))), /*#__PURE__*/React.createElement(ModalBody, {
    alignment: 'left'
  }, escape ? /*#__PURE__*/React.createElement(I18n, {
    i18n: i18n
  }) : /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: isI18nObject(i18n) ? i18n.id : i18n
    }
  })))));
}